export const QUESTION_TYPES_TEXT = Object.freeze({
    TEXT: "feedbacks:question_modal.type.text",
    CHOICE: "feedbacks:question_modal.type.choice",
    CHOICE_MULTIPLE: "feedbacks:question_modal.type.choice_multiple",
    RATING: "feedbacks:question_modal.type.rating",
    INTEGER: "feedbacks:question_modal.type.integer",
});

export const questionTypesColor = Object.freeze({
    TEXT: "blue",
    CHOICE: "violet",
    CHOICE_MULTIPLE: "teal",
    RATING: "yellow",
    INTEGER: "orange",
});

export const questionTypesIcon = Object.freeze({
    TEXT: "comment",
    CHOICE: "square",
    CHOICE_MULTIPLE: "clone",
    RATING: "star",
    INTEGER: "sort numeric descending",
});

export const chartRatesColours = [
    '#FA6250',
    '#F59B6A',
    '#EBD56A',
    '#9DD455',
    '#44AF69',
]

export const RATING_FIELDS = [
    {
        name: 'global_rating',
        icon: 'star',
        title: 'feedbacks:rating_fields.global_rating',
    },
    {
        name: 'food_rating',
        icon: 'utensils',
        title: 'feedbacks:rating_fields.food_rating',
    },
    {
        name: 'service_rating',
        icon: 'glass martini',
        title: 'feedbacks:rating_fields.service_rating',
    },
    {
        name: 'atmosphere_rating',
        icon: 'smile',
        title: 'feedbacks:rating_fields.atmosphere_rating',
    },
    {
        name: 'quality_price_rating',
        icon: 'money bill alternate outline',
        title: 'feedbacks:rating_fields.quality_price_rating',
    },
];


// WEBPACK FOOTER //
// ./src/constants/feedbacks.js